import type { ApiLeaderboardEntry, RatingEntryModel } from '~/modules/main'

export const mapLeaderboardEntryToRatingEntry = (
  entry: ApiLeaderboardEntry,
  index: number,
): RatingEntryModel => {
  const place = entry.position >= 1 ? entry.position : index + 1

  return {
    id: String(entry.publicId),
    place,
    userId: String(entry.publicId),
    title: entry.title,
    score: entry.spinsCount,
  }
}

export const mapLeaderboardTopToRatingEntries = (
  top: ApiLeaderboardEntry[],
): RatingEntryModel[] =>
  top.map((entry, index) => mapLeaderboardEntryToRatingEntry(entry, index))
